import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import type { CookieConsentChoice } from "@/components/cookie-consent"

const GA_MEASUREMENT_ID = "G-M3Q4VR2CRZ"

type GoogleAnalyticsPageViewsProps = {
  consent: CookieConsentChoice | null
}

export function GoogleAnalyticsPageViews({
  consent,
}: GoogleAnalyticsPageViewsProps) {
  const location = useLocation()

  useEffect(() => {
    if (consent !== "accepted" || !window.gtag) {
      return
    }

    window.gtag("event", "page_view", {
      send_to: GA_MEASUREMENT_ID,
      page_path: `${location.pathname}${location.search}`,
      page_location: window.location.href,
      page_title: document.title,
    })
  }, [consent, location.pathname, location.search])

  return null
}
